function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgDay = function SvgDay(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 481.882 481.882",
    style: {
      enableBackground: "new 0 0 481.882 481.882"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("circle", {
    style: {
      fill: "#FCD462"
    },
    cx: 240.941,
    cy: 240.941,
    r: 138.541
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M306.598,118.664c6.024,19.275,10.24,39.755,10.842,60.838 c3.614,83.727-53.007,157.816-126.494,190.344c15.661,6.024,32.527,9.638,49.995,9.638c76.499,0,138.541-62.042,138.541-138.541 C379.482,187.934,349.967,142.155,306.598,118.664z"
  }), React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M240.941,0c-11.445,0-20.48,9.035-20.48,20.48v33.732c0,11.445,9.035,20.48,20.48,20.48 s20.48-9.035,20.48-20.48V20.48C261.421,9.035,252.386,0,240.941,0z"
  }), React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M240.941,407.191c-11.445,0-20.48,9.035-20.48,20.48v33.732c0,11.445,9.035,20.48,20.48,20.48 s20.48-9.035,20.48-20.48v-33.732C261.421,416.226,252.386,407.191,240.941,407.191z"
  }), React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M481.882,240.941c0-11.445-9.035-20.48-20.48-20.48h-33.732c-11.445,0-20.48,9.035-20.48,20.48 s9.035,20.48,20.48,20.48h33.732C472.847,261.421,481.882,252.386,481.882,240.941z"
  }), React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M74.692,240.941c0-11.445-9.035-20.48-20.48-20.48H20.48c-11.445,0-20.48,9.035-20.48,20.48 s9.035,20.48,20.48,20.48h33.732C65.656,261.421,74.692,252.386,74.692,240.941z"
  }), React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M411.407,70.475c-7.831-7.831-21.082-7.831-28.913,0L358.4,94.569 c-7.831,7.831-7.831,21.082,0,28.913c7.831,7.831,21.082,7.831,28.913,0l24.094-24.094 C419.238,91.558,419.238,78.306,411.407,70.475z"
  }), React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M123.482,358.4c-7.831-7.831-21.082-7.831-28.913,0l-24.094,24.094 c-7.831,7.831-7.831,21.082,0,28.913c7.831,7.831,21.082,7.831,28.913,0l24.094-24.094 C131.313,379.482,131.313,366.833,123.482,358.4z"
  }), React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M411.407,411.407c7.831-7.831,7.831-21.082,0-28.913L387.313,358.4 c-7.831-7.831-21.082-7.831-28.913,0c-7.831,7.831-7.831,21.082,0,28.913l24.094,24.094 C390.325,419.238,403.576,419.238,411.407,411.407z"
  }), React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M123.482,123.482c7.831-7.831,7.831-21.082,0-28.913L99.388,70.475 c-7.831-7.831-21.082-7.831-28.913,0s-7.831,21.082,0,28.913l24.094,24.094C102.4,131.313,115.049,131.313,123.482,123.482z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/day.fbbe405e.svg";
export { ForwardRef as ReactComponent };